import { useState, useContext } from "react";
import { formatDate, notify, obtenerHoraActual } from "../../utils/utils";
import { Fetch } from "../../services/api";
import { useModal } from '../useModal';
import { UserContext } from "../../context/provider/UserProvider";

const urlProyecto = process.env.REACT_APP_XPROJECT_API + "/Proyect";


export const useProyectos = () => {
    const { stateUser } = useContext(UserContext);
    const inicioDefault = {
        codTicket:0,
        nomTicket: "",
        objetivo: "",
        alcance: "",
        interesados: "",
        codAreaDestino: 1,
        codEmpresa: 4,
        codUsuarioResponsable: 0,
        codUsuarioParticipanteConcatenado: "",
        fechaInicioProgramadoTicket: '',
        horaInicioProgramadoTicket: '',
        fechaFinProgramadoTicket: '',
        horaFinProgramadoTicket: '',
        codUsuarioSolicitante: 0,
        codTicketTipo: 3,
        codPrioridad: 3,
        parametrosArchivo: "",
        parametrosImagen: "",
        parametrosImagenRechazo: "",
        motivoRechazo: "",
        fechaHoraRechazo: "",
        nomUsuarioRechazo: "",
        fechaRegistro: '',
        // motivo:'',
        codIncidencia: 0,
        identificador: 0,
        opcionAutomatizar: 0,
        automatizarIncidencia: 0,
    }
    
    const analisisDefault = {
        codTicket: 0, 
        titulo: '',
        descripcionAnalisis: '',
        codUsuarioResponsable: 0,
        fechaInicioAnalisis: '',
        horaInicioAnalisis: '',
        fechaFinAnalisis: '',
        horaFinAnalisis: '',
        parametrosArchivo: '',
        parametrosImagen: '',
        codUsuarioParticipanteConcatenado: '',
    }

    const entregableActividadesDefault = {
        codTicket: 0,
        nomTicket: '',
        entregable: [
            {
                nomEntregable: '',
                codTicketEntregable: 0,
                actividades: [
                    {
                        codTicketActividad: 0,
                        nomActividad: '',
                        codEstadoTicketActividad: 0
                    }
                ]
            }
        ]
    }

    const finProyectoDefault = {
        codTicket: 0,
        motivoFinalizaDirecto: "",
        parametrosArchivo: '',
        parametrosImagen: ''
    }

    const ideaDefault = {
        nomTicketIdea:'',
        contenidoTicketIdea:'',
        solicitanteIdea:'',
        parametrosArchivo:'',
        parametrosImagen:''
    }

    const [ proyectos, setProyectos ] = useState([]); //Listado de proyectos
    const [ idea, setIdea ] = useState(ideaDefault);
    const [ inicio, setInicio ] = useState(inicioDefault); //Detalle de cada registro
    const [ analisis, setAnalisis ] = useState(analisisDefault);
    const [ listaAnalisis, setListaAnalisis ] = useState({
        
    });
    const [ listaProyectos, setListaProyectos ] = useState([]);
    const [ registrarArchivos, setRegistrarArchivos ] = useState(false);
    const [ registrarArchivosAnalisis, setRegistrarArchivosAnalisis ] = useState(false)
    const [ entregableActividades, setEntregableActividades ]  = useState(entregableActividadesDefault);
    const [ isOpenModalProyecto, openModalProyecto, closeModalProyecto] = useModal(false);
    const [ loading, setLoading ] = useState(false);
    const [ finProyecto, setFinProyecto ] = useState(finProyectoDefault);
    const [ calendarioTicket, setCalendarioTicket ] = useState([]);


    
    const listarProyectos = async (CodTicketTipo, fechaInicio, fechaFin) => { // Listado principal de la tabla Gestion de proyectos
        try{
            const response = await Fetch({
                url: urlProyecto + '?' + new URLSearchParams({
                    CodTicketTipo: CodTicketTipo,
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setProyectos(response.isValid ? response.content : []);
        }
        catch(error){
            setInicio([]);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar: ',error)
            setLoading(false);
        }
    }

    const obtenerIdeaProyecto = async (codTicket) => {
        try{
            if(codTicket){
                const response = await Fetch({
                    url: urlProyecto+ '/idea?' + new URLSearchParams({
                        CodTicket: codTicket
                    })
                })
                setIdea(response.isValid ? response.content: ideaDefault);
            }
            else{
                setIdea(ideaDefault);
            }
        }
        catch(e){
            // notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar idea: ',e);
            setIdea(ideaDefault);
        }
    }

    const editarValorIdeaProyecto = (key, value) => {
        setIdea( idea => {
            return {
                ...idea,
                [key]: value
            }
        })
    }

    const registrarIdeaProyecto = async(urlImagen,urlDocumento) => { // Registrar y editar
        try{
            const esGuardar = inicio.codTicket === 0 ? true : false;
            const response = await Fetch({
                url: urlProyecto + '/idea',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    codUsuarioAccion : stateUser.codUsuario,
                    nomTicketIdea: idea.nomTicketIdea,
                    contenidoTicketIdea: idea.contenidoTicketIdea||'',
                    solicitanteIdea: idea.solicitanteIdea,
                    parametrosArchivo: urlDocumento.length === 0 ? [] : urlDocumento,
                    parametrosImagen: urlImagen.length === 0 ? [] : urlImagen,
                })
            });
            if(response.isValid){
                notify(response.content.desResultado, 'success')
            }
            else{
                if(response.content.codResultado === 0){
                    notify(response.content.desResultado, 'error')
                }
                else{
                    notify(response.exceptions[0].description, 'error')
                }
            }
            return  response;
        }
        catch(e){
            notify('Ocurrió un error en el servicio');
            console.log('Error al registrar idea: ',e);
            return false;
        }
    }

    const obtenerDetalleInicioProyecto = async (codTicket) => {
        try{
            if(codTicket){
                const response = await Fetch({
                    url: urlProyecto + '/detailed?' + new URLSearchParams({
                        codTicket : codTicket
                    })
                });
                !response.isValid && notify(response.exceptions[0].description, 'error')
                setInicio(response.isValid ? response.content : inicioDefault);
            }
            else{
                setInicio(inicioDefault);
            }

        }
        catch(error){
            setInicio(inicioDefault);
            notify('Ocurrió un error en el servicio');
            console.log('Error al obtener detalle: ', error)
        }
    }

    const editarValorInicioProyecto = (key, value) => {
        setInicio(inicio => {
            return {
                ...inicio,
                [key]: value
            }
        });
    }

    const registrarInicioProyecto = async (urlImagen, urlDocumento) => {
        try{
            const fechaActual = formatDate(new Date(),103);
            const horaActual = obtenerHoraActual();
            const fechaHora = fechaActual + ' ' + horaActual;
            const esGuardar = inicio.identificador ? false : true; // El identificador estara en false si es que no hay registro guardado, en caso de que ya se haya guardado cambia a true
            const response = await Fetch({
                url: urlProyecto,
                method: esGuardar ? 'POST' : 'PUT', 
                body: JSON.stringify({
                    ...(!esGuardar && {codArea:parseInt(inicio.codAreaDestino)}),
                    codUsuarioAccion: stateUser.codUsuario,
                    ...(esGuardar && {
                        nomTicket: inicio.nomTicket,
                        codEmpresa: inicio.codEmpresa,
                        codAreaDestino: inicio.codAreaDestino,
                        codAreaOrigen: stateUser.codAreaActual,
                    }),
                    objetivo: inicio.objetivo,
                    codUsuarioResponsable: inicio.codUsuarioResponsable,
                    codUsuarioParticipanteConcatenado: inicio.codUsuarioParticipanteConcatenado,
                    fechaInicioProgramado: inicio.fechaInicioProgramadoTicket !== '' ? (inicio.fechaInicioProgramadoTicket + ' ' + inicio.horaInicioProgramadoTicket) : fechaHora,
                    fechaFinProgramado: inicio.fechaFinProgramadoTicket !== '' ? (inicio.fechaFinProgramadoTicket + ' ' + inicio.horaFinProgramadoTicket) : fechaHora,
                    codUsuarioSolicitante: inicio.codUsuarioSolicitante,
                    codTicketTipo: inicio.codTicketTipo,
                    codPrioridad: inicio.codPrioridad,
                    codIncidencia: inicio.codIncidencia,
                    parametrosArchivo:  urlDocumento.length > 0 ? urlDocumento : [],
                    parametrosImagen:  urlImagen.length > 0 ? urlImagen : [],
                    codTicket: inicio.codTicket,
                    alcance: inicio.alcance,
                    interesados: inicio.interesados,
                     ...(!esGuardar && {codEmpresa: inicio.codEmpresa,})
                })
                
            });
            notify(response.isValid? response.content : response.exceptions[0].description,(response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch{
            notify('Ocurrió un erro en el servicio','error');
        }
    }

    const registrarInicioAutomatizado = async (urlImagen, urlDocumento) => {
        try
        {
            const fechaActual = formatDate(new Date(),103);
            const horaActual = obtenerHoraActual();
            const fechaHora = fechaActual + ' ' + horaActual;
            const response = await Fetch({
                url: urlProyecto + '/automatic',
                method: 'POST',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    nomTicket: inicio.nomTicket,
                    codEmpresa: inicio.codEmpresa,
                    codAreaDestino: inicio.codAreaDestino,
                    codAreaOrigen: stateUser.codAreaActual,
                    codUsuarioResponsable: inicio.codUsuarioResponsable,
                    codUsuarioParticipanteConcatenado: inicio.codUsuarioParticipanteConcatenado,
                    fechaInicioProgramado: inicio.fechaInicioProgramadoTicket !== '' ? (inicio.fechaInicioProgramadoTicket + ' ' + inicio.horaInicioProgramadoTicket) : fechaHora,
                    fechaFinProgramado: inicio.fechaFinProgramadoTicket !== '' ? (inicio.fechaFinProgramadoTicket + ' ' + inicio.horaFinProgramadoTicket) : fechaHora,
                    codUsuarioSolicitante: inicio.codUsuarioSolicitante,
                    codTicketTipo: inicio.codTicketTipo,
                    codPrioridad: inicio.codPrioridad,
                    // codIncidencia: !inicio.codIncidencia ? 0 : inicio.codIncidencia,
                    parametrosArchivo:  urlDocumento.length > 0 ? urlDocumento : [],
                    parametrosImagen:  urlImagen.length > 0 ? urlImagen : [],
                    codTicket: inicio.codTicket,
                })
            })
            notify(response.isValid? response.content : response.exceptions[0].description,(response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch(e)
        {
            notify('Ocurrió un erro en el servicio','error');
        }
    }

    const obtenerAnalisisProyecto = async (codTicket) => {
        const response = await Fetch({
            url: urlProyecto + '/Analysis?' + new URLSearchParams({
                codTicket : codTicket
            })
        });
        if(response.isValid){
            setListaAnalisis(response.content);
        }
        else{
            notify(response.content)
        }
    }

    const editarValorAnalisisProyecto = (key,value) =>{
        setAnalisis(analisis => {
            return {
                ...analisis,
                [key]: value
            }
        });
    }

    const registrarAnalisisProyecto = async (urlImagen, urlDocumento) => {
        try{
            const esGuardar = analisis.codTicketAnalisis === 0 || analisis.codTicketAnalisis === undefined;
            const response = await Fetch({
                url: urlProyecto + '/analysis',
                method: esGuardar ? 'POST' : 'PUT', 
                body: JSON.stringify({
                    ...(
                        esGuardar?
                            {
                                codTicket: parseInt(analisis.codTicket),
                                titulo: analisis.titulo    
                            }
                        :
                            {
                                codTicketAnalisis: parseInt(analisis.codTicketAnalisis)
    
                            }
                        ),
    
                    descripcionAnalisis: analisis.descripcionAnalisis,
                    codUsuarioResponsable: stateUser.codUsuario,//para pruebas
                    fechaInicio: analisis.fechaInicioAnalisis + ' ' + analisis.horaInicioAnalisis,
                    fechaFin: analisis.fechaFinAnalisis + ' ' + analisis.horaFinAnalisis ,
                    codUsuarioAccion: stateUser.codUsuario,
                    parametrosArchivo: urlDocumento.length > 0 ? urlDocumento : [],
                    parametrosImagen: urlImagen.length > 0 ? urlImagen : [],
                    codUsuarioParticipanteConcatenado: analisis.codUsuarioParticipanteConcatenado || "" ,
                })
    
            });
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al guardar: ',error);
            return false;
        }
    }

    const eliminarAnalisisProyecto = async (codTicketAnalisis) => {
        try{
            const response = await Fetch({
                url: urlProyecto + '/analysis',
                method: 'DELETE', 
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodTicketAnalisis: codTicketAnalisis
                })
    
            });
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al eliminar analisis: ',error);
            return false;
        }
    }

    const listarEntregableActividadPorTicket = async (codTicketTipo) => {
        try{
            const response = await Fetch({
                url: urlProyecto + '/deliverableActivities?' + new URLSearchParams({
                    CodTicket: codTicketTipo
                })
            })
            setEntregableActividades(response.isValid ? response.content : entregableActividadesDefault);
        }
        catch(error){
            notify('Ocurrió un error en el servicio','error');
            setEntregableActividades(entregableActividadesDefault);
            console.log('Error al listar entregable: ',error)
        }
    }

    const listarFinalizarProyecto = async (codTicket) => {
        try{
            const response = await Fetch({
                url: urlProyecto + '/finalizar?' + new URLSearchParams({
                    CodTicket: codTicket
                }),
                method: 'GET',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setFinProyecto(response.isValid ? response.content : finProyectoDefault)
        }
        catch(e){
            setFinProyecto(finProyectoDefault);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar el detalle de finalizar proyecto: ',e);
        }
    }

    const finalizarProyecto = async (codTicket,urlImagen, urlDocumento) => {
        try{
            const response = await Fetch({
                url: urlProyecto + '/finalizar',
                method: 'PUT',
                body: JSON.stringify({
                    codTicket: codTicket,
                    codUsuarioAccion: stateUser.codUsuario,
                    motivo: finProyecto.motivoFinalizaDirecto,
                    parametrosImagen: urlImagen.length > 0 ? urlImagen : [],
                    parametrosArchivo: urlDocumento.length > 0 ? urlDocumento: [],
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description, response.isValid ? 'success' : 'error')
            return response.isValid 
        }
        catch(error){
            notify('Ocurrió un problema en el servicio','error');
            console.log('Error al registrar: ',error);
            return false
        }
    }

    const editarValorFinalizarProyecto = (key, value) =>{
        setFinProyecto(finProyecto => {
            return {
                ...finProyecto,
                [key]: value
            }
        })
    }

    const listarTicketPorMes = async (mes,anio) => {
        try{
            const response = await Fetch({
                url: urlProyecto + '/calendarManagement?' +new URLSearchParams({
                    Mes: mes + 1,
                    Anio: anio,
                    CodArea: stateUser.codAreaActual
                }),
                method: 'GET',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setCalendarioTicket(response.isValid? response.content : [])
        }
        catch(error){
            setCalendarioTicket([])
            notify('Ocurrió un problema en el servicio','error');
            console.log('Error al registrar: ',error);
        }
    }

    const listarTicketProyectos = async (fechaInicio, fechaFin, codUsuario) => {
        try
        {
            const response = await Fetch({
                url: urlProyecto + '/projectFilter?' +new URLSearchParams({
                    FechaInicio: fechaInicio,
                    FechaFin: fechaFin,
                    CodUsuario: codUsuario
                }),
                method: 'GET',
            })
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setListaProyectos(response.isValid? response.content : [])
        }
        catch(e)
        {
            setListaProyectos([])
            notify('Ocurrió un problema en el servicio','error');
            console.log('Error al listar filtro proyectos: ',e);
        }
    }

    const rechazarTicket = async (codTicket, motivo, urlImagen) =>  {
        try{
            const response = await Fetch({
                url: urlProyecto + '/rejectTicket',
                method: 'DELETE', 
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codTicket: codTicket,
                    motivoRechazo: motivo,
                    parametrosImagen:  urlImagen.length > 0 ? urlImagen : [],
                })
                
            });
            notify(response.isValid? response.content : response.exceptions[0].description,(response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch{
            notify('Ocurrió un erro en el servicio','error');
        }
    }
    
    return {
        listarProyectos,
        proyectos,
        obtenerIdeaProyecto,
        idea,
        editarValorIdeaProyecto,
        registrarIdeaProyecto,
        obtenerDetalleInicioProyecto,
        inicio,
        editarValorInicioProyecto,
        registrarInicioProyecto,
        analisis,
        listaAnalisis,
        obtenerAnalisisProyecto,
        registrarAnalisisProyecto,
        editarValorAnalisisProyecto,
        registrarArchivos,
        setRegistrarArchivos,
        isOpenModalProyecto,
        openModalProyecto,
        closeModalProyecto,
        inicioDefault,
        registrarArchivosAnalisis,
        setRegistrarArchivosAnalisis,
        listarEntregableActividadPorTicket,
        entregableActividades,
        setAnalisis,
        analisisDefault,
        loading,
        finalizarProyecto,
        editarValorFinalizarProyecto,
        finProyecto,
        setFinProyecto,
        finProyectoDefault,
        listarFinalizarProyecto,
        setLoading,
        eliminarAnalisisProyecto,
        listarTicketPorMes,
        calendarioTicket,
        registrarInicioAutomatizado,
        listarTicketProyectos,
        listaProyectos,
        rechazarTicket
    };
}